export default function ({ store }) {
  // Close drawer on router change
  store.commit('updateDrawerState', false);
}
